"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _useFocusTrap = _interopRequireDefault(require("../hooks/useFocusTrap"));
var _Portal = _interopRequireDefault(require("../Portal"));
var _useTheme = _interopRequireDefault(require("../hooks/useTheme"));
var _Heading = _interopRequireDefault(require("../Heading"));
var _Text = _interopRequireDefault(require("../Text"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _useLockScrolling = _interopRequireDefault(require("../hooks/useLockScrolling"));
var _keyMaps = _interopRequireDefault(require("../common/keyMaps"));
var _useClickOutside = _interopRequireDefault(require("../hooks/useClickOutside"));
var _useRandomId = _interopRequireDefault(require("../hooks/useRandomId"));
const ActionButtonWrapper = ({
  children
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "lm:w-auto lm:[&>button]:flex-none lm:[&>button]:w-auto w-full [&>button]:w-full [&>button]:flex-auto"
  }, children);
};
const Dialog = ({
  dataTest,
  id,
  title,
  description,
  primaryAction,
  secondaryAction,
  onClose,
  maxWidth,
  renderInPortal = true,
  illustration,
  lockScrolling = true
}) => {
  const wrapperRef = React.useRef(null);
  (0, _useLockScrolling.default)(wrapperRef, lockScrolling);
  const ref = React.useRef(null);
  const theme = (0, _useTheme.default)();
  const [shown, setShown] = React.useState(false);
  (0, _useFocusTrap.default)(ref);
  React.useEffect(() => {
    const transitionLength = parseFloat(theme.orbit.durationFast) * 1000;
    const timer = setTimeout(() => {
      setShown(true);
      if (ref.current) {
        ref.current.focus();
      }
    }, transitionLength);
    const handleKeyDown = ev => {
      if (ev.keyCode === _keyMaps.default.ESC && onClose) {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      clearTimeout(timer);
    };
  }, [theme.orbit.durationFast, onClose]);
  const handleClose = ev => {
    if (ref && ref.current && onClose) {
      if (ref.current && !ref.current.contains(ev.target)) onClose();
    }
  };
  (0, _useClickOutside.default)(ref, handleClose);
  const dialogID = (0, _useRandomId.default)();
  const descriptionId = (0, _useRandomId.default)();
  const dialog = /*#__PURE__*/React.createElement("div", {
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": dialogID,
    "aria-describedby": descriptionId,
    ref: wrapperRef,
    "data-test": dataTest,
    id: id,
    className: (0, _clsx.default)(["font-base", "size-full", "p-md z-overlay box-border overflow-x-hidden bg-[rgba(0,0,0,0.5)]", "fixed inset-0", "duration-fast transition-opacity ease-in-out", "lm:opacity-100 lm:flex lm:items-center lm:justify-center"])
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex min-h-full items-center"
  }, /*#__PURE__*/React.createElement("div", {
    id: dialogID,
    ref: ref,
    style: {
      maxWidth
    },
    className: (0, _clsx.default)(["shadow-overlay pt-lg px-md pb-md bg-white-normal rounded-dialog-mobile box-border block w-full", shown ? "bottom-0" : "-bottom-full", "lm:min-w-dialog-width lm:p-lg lm:rounded-dialog-desktop"])
  }, illustration && /*#__PURE__*/React.createElement("div", {
    className: "mb-md lm:text-start text-center"
  }, illustration), /*#__PURE__*/React.createElement("div", {
    className: "mb-md gap-xs lm:text-start lm:[&>.orbit-text]:text-start flex flex-col text-center [&>.orbit-text]:text-center"
  }, title && /*#__PURE__*/React.createElement(_Heading.default, {
    type: "title3",
    align: "center",
    largeMobile: {
      align: "start"
    }
  }, title), description && /*#__PURE__*/React.createElement(_Text.default, {
    type: "secondary",
    id: descriptionId
  }, description)), /*#__PURE__*/React.createElement(_Stack.default, {
    direction: "column-reverse",
    spacing: "XSmall",
    largeMobile: {
      direction: "row",
      justify: "end"
    }
  }, secondaryAction && /*#__PURE__*/React.createElement(ActionButtonWrapper, null, secondaryAction), /*#__PURE__*/React.createElement(ActionButtonWrapper, null, primaryAction)))));
  return renderInPortal ? /*#__PURE__*/React.createElement(_Portal.default, {
    renderInto: "modals"
  }, dialog) : dialog;
};
var _default = Dialog;
exports.default = _default;